import { useContext, useState, useEffect } from "react";
import { Embed, Message } from 'semantic-ui-react';
import { PrivacyPolicyContext } from 'volto-fzj-internet/components/manage/PrivacyPolicy/PrivacyPolicyContext';
import { useIntl, defineMessages, FormattedMessage } from 'react-intl';


export default function PrivacyPolicyWrapper({ placeholder, wrappingSettings, service }) {
    const { cookies, setCookies } = useContext(PrivacyPolicyContext);
    const intl = useIntl();
    const [showBlock, setShowBlock] = useState(false);
    const privacyPolicyText = "By {block}, you will be redirected to {service}. The provider’s privacy policy applies."
    function setWrapperVisibility() {
        setCookies(service, true, { path: "/" })
    }
    function capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
    }
    const messages = defineMessages({
        privacyPolicyVideo: {
            id: 'desVideos',
            defaultMessage: 'playing this video',
        },
        privacyPolicyMap: {
            id: 'derKarte',
            defaultMessage: 'opening this map',
        },
        agreeButtonText: {
            id: 'agreeButton',
            defaultMessage: 'Agree and show {block}'
        },
        agreeButtonMap: {
            id: 'karte',
            defaultMessage: 'map'
        },
        agreeButtonVideo: {
            id: 'buttonVideo',
            defaultMessage: 'video'
        }
    });
    useEffect(() => {
        if (cookies[service] === "true") {
            setShowBlock(true);
        }
    }, [cookies]);
    
    return (
        <div className={`embed-wrapper`} >
            {service.match("googl") ? (
                showBlock ? (
                    <iframe
                        title={wrappingSettings.title}
                        src={wrappingSettings.url}
                        frameBorder="0"
                        allowFullScreen
                        className="google-map"
                    />
                ) : <iframe />) : (<Embed
                    {...wrappingSettings}
                    active={showBlock}
                />)}
            {cookies[service] !== "true" && (
                <div
                    className={
                        wrappingSettings.align === "left" || wrappingSettings.align === "right"
                            ? `custom-placeholder-wrapper ${wrappingSettings.align}`
                            : "custom-placeholder-wrapper"
                    }
                >
                    {placeholder && (<img
                        className="placeholder-image"
                        src={placeholder}
                        alt=""
                    />)}
                    <div className="overlay-row">
                        <p className="overlay-text">
                            <FormattedMessage
                                id="privacyPolicy"
                                defaultMessage={privacyPolicyText}
                                values={{ block: <span>{service.match('googl') ? intl.formatMessage(messages.privacyPolicyMap) : intl.formatMessage(messages.privacyPolicyVideo)}</span>, service: <span>{capitalizeFirstLetter(service)}</span> }}
                            />
                        </p>
                        <button
                            className="embed-button"
                            onClick={setWrapperVisibility}
                        >
                            {intl.formatMessage(messages.agreeButtonText, { block: service.match('googl') ? intl.formatMessage(messages.agreeButtonMap) : intl.formatMessage(messages.agreeButtonVideo) })}
                        </button>

                    </div>
                </div>
            )}
        </div>
    )
}

